/**
 * ItemRequire1Type
 * @param {*} Require1Type
 */

export default (Require1Type) => {
    return Require1Type === 5
        ? '需要等级'
        : Require1Type
}

